import * as mutationTypes from './mutation-types'
import api from '@/store/api/customer'
import {find} from 'lodash'

const initialState = () => ({
    selected: null,
    metrics: []
})

export default {
    namespaced: true,
    state: initialState(),
    getters: {
        metric: state => find(state.metrics, {id: state.selected}),
        metrics: state => state.metrics
    },
    actions: {
        /**
         * @param {{customerId: number}} data
         * @returns {Promise<*>}
         */
        listMetrics: async ({commit, dispatch}, data) => {
            try {
                const response = await api.listCustomerMetrics(data)

                commit(mutationTypes.SET_METRICS, response.data)
                return response.data
            } catch (e) {
                const errorResponse = await dispatch('errors/addErrors', [e], {root: true})
                return Promise.reject(errorResponse[0])
            }
        },
        selectMetric: async ({commit}, id) => commit(mutationTypes.SET_METRIC, id),
        resetMetric: async ({commit}, id) => commit(mutationTypes.RESET_METRIC, id),
        resetMetrics: ({commit}) => commit(mutationTypes.RESET_METRICS)
    },
    mutations: {
        [mutationTypes.RESET_METRICS]: (state) => Object.assign(state, initialState()),
        [mutationTypes.RESET_METRIC]: (state) => state.selected = null,
        [mutationTypes.SET_METRIC]: (state, id) => state.selected = id,
        [mutationTypes.SET_METRICS]: (state, data) => state.metrics = data
    }
}
